export const LOADING = Symbol();

export type Loading = typeof LOADING;

export function isLoading(value: unknown | Loading): value is Loading {
  return value === LOADING;
}
